// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedLineItem: Any,
};

const outForDelivery = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedLineItem,
  } = props;

  const updateItem = () => {
    submit(selectedLineItem);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">No</SpButton>,
        <SpButton onClick={updateItem} type="primary">Yes</SpButton>,
      ]}
      title="Update Order Status"
    >
      <div className="px-4">
        <SpH5 className="pb-3">
          <div>Please confirm to move the order to out for delivery</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default outForDelivery;
